module.exports = __webpack_public_path__ + "media/08.30ee09f0.mp4";